import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Save Schedule Edits", -1)
const _hoisted_2 = { class: "assignment-details" }
const _hoisted_3 = {
  key: 0,
  class: "event-type-block"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Updated Events:")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "note-indicator" }, "*", -1)
const _hoisted_6 = {
  key: 0,
  class: "extension-notes"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "note-indicator" }, "*"),
  /*#__PURE__*/_createTextVNode(" Things to Note:")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Tandem does not automatically notify students of a deadline extension. "),
  /*#__PURE__*/_createElementVNode("li", null, " Extending the deadline on the Beginning of Term Survey may require you to move the Teams Visible date. "),
  /*#__PURE__*/_createElementVNode("li", null, " Extending the deadline on the Midterm Feedback Survey may require you to move the release date of the Midterm Reflection lesson. "),
  /*#__PURE__*/_createElementVNode("li", null, " Tandem will not automatically grant credit to students who completed the assignment after the original deadline, but before the extension. You may grant credit to these students manually. ")
], -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "event-type-block"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("b", null, "New Events:")
], -1)
const _hoisted_12 = {
  key: 2,
  class: "event-type-block"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Deleted Events:")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, " Once you save your schedule edits, they will automatically be applied to your Term and reflected to the students. Do you want to save your edits? ")
], -1)
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { key: 1 }

import { computed } from "vue";
import { SchedulePlan } from "@/core";
import TandemModal from "@/components/TandemModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PlannerFinalizeModal',
  props: {
    plan: {},
    finalizing: { type: Boolean }
  },
  emits: ["finalize", "cancel"],
  setup(__props: any) {

const props = __props;



const modifications = computed(() =>
  props.plan.changes.modifications.map((m) => m.description)
);
const extensions = computed(() =>
  props.plan.changes.extensions.map((e) => e.description)
);
const deletions = computed(() =>
  props.plan.changes.deletions.map((d) => d.description)
);
const additions = computed(() =>
  props.plan.changes.additions.map((a) => a.description)
);
const showThingsToNote = computed(() => !!extensions.value.length);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TandemModal, _mergeProps(_ctx.$attrs, { class: "schedule-edit-confirm" }), {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    directions: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (modifications.value.length || extensions.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modifications.value, (modification) => {
                  return (_openBlock(), _createElementBlock("li", { key: modification }, _toDisplayString(modification), 1))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extensions.value, (extension) => {
                  return (_openBlock(), _createElementBlock("li", { key: extension }, [
                    _createTextVNode(_toDisplayString(extension) + " ", 1),
                    _hoisted_5
                  ]))
                }), 128))
              ]),
              (showThingsToNote.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (additions.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additions.value, (addition) => {
                  return (_openBlock(), _createElementBlock("li", { key: addition }, _toDisplayString(addition), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (deletions.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deletions.value, (deletion) => {
                  return (_openBlock(), _createElementBlock("li", { key: deletion }, _toDisplayString(deletion), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_14
      ])
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("button", {
        class: "btn",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
      }, " Cancel "),
      _createElementVNode("button", {
        class: "btn btn-burg",
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('finalize'))),
        disabled: _ctx.finalizing
      }, [
        (!_ctx.finalizing)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" Yes, Save Edits ")
            ], 64))
          : (_openBlock(), _createElementBlock("i", _hoisted_16, " Saving edits… "))
      ], 8, _hoisted_15)
    ]),
    _: 1
  }, 16))
}
}

})